<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1">Book One</h1>
<h1 class="center"><i>Fortune’s Whirlwind</i></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-chap1.vue?4be6baa7